/**
 * HeaderSearch component.
 * @module components/Header/HeaderSearch
 * Customizations
 * Navigate to custom search site when clicked on main site
 * Hide on custom search site
 */

import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { SearchModal } from 'design-comuni-plone-theme/components/ItaliaTheme';

const messages = defineMessages({
  search: {
    id: 'Cerca',
    defaultMessage: 'Cerca',
  },
});

const HeaderSearch = () => {
  const intl = useIntl();
  const [showSearchModal, setShowSearchModal] = useState(false);

  const isSearchSite =
    (__CLIENT__ && window.env.RAZZLE_SOLR_SEARCH_SITE) ||
    process.env.RAZZLE_SOLR_SEARCH_SITE ||
    false;

  const solrSearchUrl =
    (__CLIENT__ && window.env.RAZZLE_SOLR_SEARCH_URL) ||
    process.env.RAZZLE_SOLR_SEARCH_URL ||
    '';

  return (
    !isSearchSite && (
      <>
        <div className="it-search-wrapper">
          <span className="d-none d-md-block">
            {intl.formatMessage(messages.search)}
          </span>
          <a
            className="search-link rounded-icon"
            aria-label={intl.formatMessage(messages.search)}
            onClick={(e) => {
              if (!solrSearchUrl) {
                e.preventDefault();
                setShowSearchModal(true);
              }
            }}
            href={solrSearchUrl || '/search'}
          >
            <Icon
              icon="it-search"
              title={intl.formatMessage(messages.search)}
            />
          </a>
        </div>
        <SearchModal
          show={showSearchModal}
          closeModal={() => setShowSearchModal(false)}
        />
      </>
    )
  );
};

export default HeaderSearch;
